module.exports = __webpack_public_path__ + "static/img/163_TO8_1900_og.9ca45de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/163_TO8_1900_og.jpg
// module id = ycsw
// module chunks = 0